import React from "react";

/**
 * @component AttachmentIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <AttachmentIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const AttachmentIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="AttachmentIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12.814 2.454l1.414 1.414-8.485 8.486a4 4 0 005.512 5.794l.144-.138 8.132-8.131a1.5 1.5 0 00-2.014-2.219l-.107.097-8.58 8.58-1.414-1.414 8.58-8.58a3.5 3.5 0 015.082 4.81l-.133.14-8.131 8.132A6 6 0 014.172 11.1l.156-.162 8.486-8.485z"
        fillRule="evenodd"
      />
    </svg>
  )
);
AttachmentIcon.displayName = "AttachmentIcon";
export default AttachmentIcon;
